import { Link } from 'react-router-dom';
import './Commercial.css';
import { FaBuilding, FaChartBar, FaFileContract, FaHandshake, FaTools, FaMoneyBillWave, FaUsers, FaClipboardList } from 'react-icons/fa';

export default function Commercial() {
  const services = [
    {
      icon: <FaBuilding />,
      title: 'Property Leasing',
      description: 'Expert leasing services for office spaces, retail shops, warehouses, and commercial complexes.'
    },
    {
      icon: <FaChartBar />,
      title: 'Market Analysis',
      description: 'Comprehensive market research and competitive analysis for optimal property positioning.'
    },
    {
      icon: <FaFileContract />,
      title: 'Lease Management',
      description: 'Complete lease administration, renewals, and documentation support for commercial properties.'
    },
    {
      icon: <FaHandshake />,
      title: 'Tenant Acquisition',
      description: 'Strategic tenant sourcing and screening to find the right businesses for your property.'
    },
    {
      icon: <FaTools />,
      title: 'Property Maintenance',
      description: 'Regular maintenance coordination and facility management for commercial properties.'
    },
    {
      icon: <FaMoneyBillWave />,
      title: 'Rent Collection',
      description: 'Efficient rent collection, financial reporting, and accounting services.'
    },
    {
      icon: <FaUsers />,
      title: 'Tenant Relations',
      description: 'Professional management of tenant communications and service requests.'
    },
    {
      icon: <FaClipboardList />,
      title: 'Compliance Management',
      description: 'Ensuring all commercial leases meet legal requirements and regulatory standards.'
    }
  ];

  const propertyTypes = [
    {
      title: 'Office Spaces',
      description: 'Corporate offices, co-working spaces, and business centers',
      image: 'https://images.pexels.com/photos/380768/pexels-photo-380768.jpeg?auto=compress&cs=tinysrgb&w=800'
    },
    {
      title: 'Retail Properties',
      description: 'Shopping malls, showrooms, and standalone retail outlets',
      image: 'https://images.pexels.com/photos/264636/pexels-photo-264636.jpeg?auto=compress&cs=tinysrgb&w=800'
    },
    {
      title: 'Industrial Spaces',
      description: 'Warehouses, factories, and logistics facilities',
      image: 'https://images.pexels.com/photos/1267338/pexels-photo-1267338.jpeg?auto=compress&cs=tinysrgb&w=800'
    },
    {
      title: 'Mixed-Use Developments',
      description: 'Commercial complexes with multiple property types',
      image: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=800'
    }
  ];

  const benefits = [
    'Extensive network of verified commercial tenants',
    'Transparent pricing with competitive commission rates',
    'Complete legal and documentation support',
    'Regular property inspections and maintenance',
    'Digital lease management system',
    'Quick turnaround time for tenant placement',
    '24/7 support for property owners and tenants',
    'Detailed financial reporting and analytics'
  ];

  return (
    <>
      <section className="commercial-hero">
        <div className="commercial-hero-content">
          <h1>Commercial Property Services</h1>
          <p>Comprehensive solutions for your commercial real estate needs</p>
        </div>
      </section>

      <section className="commercial-intro">
        <div className="commercial-container">
          <div className="intro-content">
            <h2>Expert Commercial Real Estate Management</h2>
            <p>
              We provide end-to-end commercial property services for office spaces, retail outlets, warehouses, 
              and mixed-use developments. Our experienced team helps property owners maximize returns while 
              ensuring smooth operations and tenant satisfaction.
            </p>
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="commercial-container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="property-types-section">
        <div className="commercial-container">
          <h2 className="section-title">Property Types We Handle</h2>
          <div className="property-types-grid">
            {propertyTypes.map((type, index) => (
              <div key={index} className="property-type-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="property-type-image">
                  <img src={type.image} alt={type.title} />
                </div>
                <div className="property-type-content">
                  <h3>{type.title}</h3>
                  <p>{type.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="benefits-section">
        <div className="commercial-container">
          <div className="benefits-wrapper">
            <div className="benefits-content">
              <h2>Why Choose Our Commercial Services?</h2>
              <ul className="benefits-list">
                {benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </div>
            <div className="benefits-image">
              <img 
                src="https://images.pexels.com/photos/416405/pexels-photo-416405.jpeg?auto=compress&cs=tinysrgb&w=800" 
                alt="Commercial Property" 
              />
            </div>
          </div>
        </div>
      </section>

      <section className="commercial-cta">
        <div className="commercial-container">
          <div className="cta-content">
            <h2>Need Commercial Property Solutions?</h2>
            <p>Connect with our commercial real estate experts today</p>
            <Link to="/contact" className="cta-button">
              Get Started
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
